import React, { useState, useEffect } from "react";
import { Table, Spin } from "antd";
import TopBar from "../../components/TopBar/TopBar";
import { useNavigate } from "react-router-dom";
import { getFavorites } from "../../utils/searchCars";
import "./Cart.scss";
import { Car } from "../../types/home";
import { CarProvider } from "../../components/CarContext/CarContext";
import { formatCarData } from "../../utils/formatCarData";
import { defaultFilterValues, FilterValues } from "../../types/home";

const Cart: React.FC = () => {
  const [filterValues, setFilterValues] =
    useState<FilterValues>(defaultFilterValues);

  const [loading, setLoading] = useState(false);
  const [cars, setCars] = useState<Car[]>([]);
  const [filteredCars, setFilteredCars] = useState<Car[]>([]);
  const navigate = useNavigate();

  // Fetch the cars when the component mounts
  useEffect(() => {
    const fetchCars = async () => {
      setLoading(true);

      try {
        const data = await getFavorites();
        console.log("Favorites Data:", data);
        // Assuming the API response contains a property called "cars"
        if (data) {
          setCars(data.cars || []);
          setFilteredCars(data.cars || []); // Set filteredCars directly
        }
      } catch (error) {
        console.error("Error fetching cars", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCars();
  }, []);

  useEffect(() => {
    if (cars) {
      const formattedData = formatCarData(cars);
      setFilteredCars(formattedData);
      calculateSubtotal(); // Recalculate the subtotal
    }
  }, [cars]);

  // Calculate the subtotal when filteredCars changes
  useEffect(() => {
    if (filteredCars.length > 0) {
      calculateSubtotal();
    }
  }, [filteredCars]);

  const calculateSubtotal = () => {
    let subtotal = 0;
    for (let car of filteredCars) {
      const bidString = car.currentBid ? car.currentBid : "0";
      const price = parseFloat(bidString.replace(/[^0-9.-]+/g, ""));
      const quantity = 1;
      subtotal += isNaN(price) ? 0 : price * quantity;
    }
    return `${subtotal.toFixed(2)}`;
  };

  // Define columns for a checkout-friendly table layout
  const columns = [
    {
      title: "Vehicle",
      dataIndex: "name",
      key: "name",
      render: (text: string, record: any) => (
        <div className="product-info">
          <img
            src={record.image}
            alt={text}
            className="product-image"
            onError={(e) => {
              e.currentTarget.src = "/fallback-image.png"; // optional fallback image
            }}
          />
          <span>{record.name}</span>
        </div>
      ),
    },
    {
      title: "Price",
      dataIndex: "currentBid",
      key: "price",
      render: (price: string) => {
        const bidString = price ? price : "0";
        return <span>{bidString}</span>;
      },
    }
  ];

  return (
    <CarProvider cars={cars}>
      <div className="checkout-page">
        <TopBar title="Favorites" />
        <div className="checkout-container">
          <div className="items-section">
            <h2>Items in Cart</h2>
            <Spin spinning={loading}>
              <Table
                dataSource={filteredCars}
                columns={columns}
                pagination={false}
                rowKey={(record) => record.key}
                onRow={(record) => ({
                  onClick: () => {
                    const encodedKey = encodeURIComponent(record.key);
                    navigate(`/car/${encodedKey}`, { state: { car: record } });
                  },
                  style: { cursor: "pointer" },
                })}
              />
            </Spin>

          </div>

        </div>
      </div>
    </CarProvider>
  );
};

export default Cart;
